import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  client_id: yup.string().required("Client ID is required"),
  client_secret: yup.string().required("Secret key is required"),
  merchant_code: yup.string().required("Merchant code is required"),
  merchant_name: yup.string().required("Merchant name is required"),
  webhook_secret: yup.string().optional(),
});

const useValidation = ({ ...formDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formDetails,
    },
  });
};

export default useValidation;
